import { render, staticRenderFns } from "./designSamples.vue?vue&type=template&id=83adabee&scoped=true"
import script from "./designSamples.vue?vue&type=script&lang=js"
export * from "./designSamples.vue?vue&type=script&lang=js"
import style0 from "./designSamples.vue?vue&type=style&index=0&id=83adabee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83adabee",
  null
  
)

export default component.exports